import { render, staticRenderFns } from "./Efooter.vue?vue&type=template&id=0c398a66"
import script from "./Efooter.vue?vue&type=script&lang=js"
export * from "./Efooter.vue?vue&type=script&lang=js"
import style0 from "./Efooter.vue?vue&type=style&index=0&id=0c398a66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports